module.exports = __webpack_public_path__ + "eff9d8579120bff28bc3baa3971014d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/subImg/wenquan_yj.png
// module id = 1171
// module chunks = 0